import { render, staticRenderFns } from "./DesktopInlineB.vue?vue&type=template&id=1d66a654&"
import script from "./DesktopInlineB.vue?vue&type=script&lang=js&"
export * from "./DesktopInlineB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports